import { availableAuthServices } from "constants/index";
import React from "react";

const ServiceSignInOptions = () => {
    const authWithService = (serviceName: string) => {
        window.open(`${process.env.NEXT_PUBLIC_BACKEND}/auth/${serviceName}`, "_self");
    };

    return (
        <div className="flex items-center justify-between">
            {availableAuthServices.map((authService) => (
                <div
                    key={authService.id}
                    onClick={() => authWithService(authService.name)}
                    className="flex size-12 cursor-pointer items-center justify-center rounded-full bg-white shadow-box-extra-light transition-colors duration-300 ease-out-cubic hover:bg-gray-50 dark:bg-gray-100 dark:hover:bg-gray-200"
                >
                    <img src={authService.iconSrc} className="size-6 fill-white" alt={authService.name} />
                </div>
            ))}
        </div>
    );
};

export default ServiceSignInOptions;
